export default __webpack_public_path__ + "static/media/slide3.13b7c76e.jpg";